// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__uBFUh","content":"Consent_content__1bMyW","footer":"Consent_footer__2uc2j"};